// Module
var code = `<!-- clLede — opening statement for a page or major section.
     Data shape: { text: "lede string (markdown)" }
     Always renders as a single <p> with larger type. -->
<div class="block-cl-lede">
  <p class="block-cl-lede__text">{{text}}</p>
</div>
`;
// Exports
module.exports = code;